import React, { useState } from 'react';
import { Package } from 'lucide-react';

export interface ProductImageProps {
  src?: string | null;
  alt: string;
  className?: string;
}

export const ProductImage: React.FC<ProductImageProps> = ({
  src,
  alt,
  className = 'h-10 w-10',
}) => {
  const [error, setError] = useState(false);

  if (!src || error) {
    return (
      <div
        className={`flex shrink-0 items-center justify-center rounded-md border border-neutral-200 bg-neutral-100 text-neutral-400 ${className}`}
        aria-hidden="true"
      >
        <Package className="h-5 w-5" />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt}
      loading="lazy"
      decoding="async"
      onError={() => setError(true)}
      className={`shrink-0 rounded-md border border-neutral-200 object-cover ${className}`}
    />
  );
};
